import { Component, OnInit, ViewEncapsulation, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { AlertService } from '@shared-services/alert.service';
import Swal from 'sweetalert2';
import { HttpErrorResponse } from '../../../../../../../node_modules/@angular/common/http';
import { AppConfig } from '@shared-configs/app-config';
import { AppHelper } from '@shared-helpers/app-helper';
import { MessageComponent } from '@global-message/Message.component';
import { UserImageRequestModel } from '@global-models/Request/UserImageRequestModel';
import { AuthenticationService } from '@auth-services/authentication.service';
import { TokenModel } from '@auth-models/Request/TokenRequestModel';
import { UserResponseModel } from '@auth-models/Response/UserResponseModel';
import { UserModel } from 'app/vbt-back-office/Role/Models/UserModel';
import { HistoryService } from 'app/vbt-ticari/common/_services/History.service';
import { UserAllLogRequestModel } from 'app/vbt-ticari/common/_models/UserAllLogRequestModel';
import { SearchResponseModel } from 'app/vbt-ticari/common/_models/SearchResponseModel';
import { SearchRequestModel } from 'app/vbt-ticari/common/_models/SearchRequestModel';
import { UserService } from 'app/vbt-back-office/Role/Services/User.service';
import { AllModules, GridOptions, Module } from '@ag-grid-enterprise/all-modules';
import { AgGridGlobalSettings } from '@global-ag-grid/ag-grid-global-settings';
import { AgGridLocaleText } from '@global-ag-grid/locale-text';



@Component({
  selector: 'm-grid__item m-grid__item--fluid m-wrapper',
  templateUrl: './header-profile.component.html',
  styleUrls: ['./header-profile.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class HeaderProfileComponent implements OnInit, AfterViewInit {
  public userModel: UserModel;
  public passwordChangeStatus = true;
  public changePassword = false;
  public selectedRows: any[];
  public allMode: string;
  public checkBoxesMode: string;
  public userOldPassword: string;
  public dateactive = false;
  public dataSource: any = {};
  public pass = JSON.parse(localStorage.getItem('DashboardPass')) as TokenModel;
  public PhoneNumber: any;
  public maskPhone = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/];
  public UploadUrl = AppConfig.backOfficeUrl + '/api/User/UploadUserImage';
  public selectedFiles: FileList;
  public portletBodyHeight: number = 0;

  public modules: Module[] = AllModules;
  public gridApi: any;
  public gridColumnApi: any;
  public gridOptions: GridOptions;
  public paginationPageSize: number;
  public columnDefs: any;
  public rowData: any;

  @ViewChild('filesupload') filesupload: ElementRef;
  @ViewChild('messageVbt') msgVbt: MessageComponent;

  constructor(private _service: UserService,
    private _login: AuthenticationService,
    private _historyService: HistoryService,
    private alertService: AlertService) {
    this.allMode = 'page';
    this.checkBoxesMode = 'always';
    this.userModel = new UserModel();
    Swal.mixin({ heightAuto: false });
  }


  ngOnInit() {
    this.portletBodyHeight = window.innerHeight - 225;
    this.GetGridSetting();
    this.GetColumnsDefs();


  }

  ngAfterViewInit(): void {
    if (this.userModel.Id === 0) {
      this.GetUser();
    }
  }

  //#region agGrid
  GetGridSetting() {
    this.paginationPageSize = 100;
    this.gridOptions = {
      localeText: AgGridLocaleText.LocaleTextTR(),
      defaultColDef: {
        resizable: true,
        sortable: true,
        filter: false,
        editable: false,
      },
      accentedSort: true,
      animateRows: true,
      enableRangeSelection: true,
      suppressRowClickSelection: true,
      rowSelection: "multiple",
      rowHeight: 33,
      pagination: true,
      rowModelType: "serverSide",
      suppressMultiSort: true,
      paginationPageSize: this.paginationPageSize,
      cacheBlockSize: this.paginationPageSize,
      maxBlocksInCache: 1,
      frameworkComponents: {
        // btnCellRenderer: IncomingEnvelopeListButtonComponent,
      },
      getRowNodeId: function (params) {
        return params.Id;
      },
      paginationNumberFormatter: function (params) {
        return (
          '<span style="font-weight:bold !important;">[' +
          params.value.toLocaleString() +
          "]</span>"
        );
      },
      excelStyles: [
        {
          id: "gridGeneralType",
          font: {
            fontName: "Calibri",
            size: 11,
          },
        },
        {
          id: "gridNumberType",
          dataType: "number",
        },
        {
          id: "gridStringType",
          dataType: "string",
        },
        {
          id: "gridDecimalType",
          dataType: "number",
          numberFormat: { format: "#,##0.00" },
        },
        {
          id: "gridBoolType",
          dataType: "boolean",
        },
        {
          id: "gridDateTimeType",
          dataType: "dateTime",
          numberFormat: { format: AgGridGlobalSettings.ExcelDataTimeFormat() },
        },
        {
          id: "gridDateType",
          dataType: "dateTime",
          numberFormat: { format: AgGridGlobalSettings.ExcelDateFormat() },
        },
      ],
    };
  }

  GetColumnsDefs() {
    const that = this;
    that.columnDefs = [];
    let responseList = [];

    responseList.push(
      {
        headerName: "Tarih",
        field: "LogDate",
        minWidth: '200',
        valueFormatter: (params) => {
          return AgGridGlobalSettings.DateLocalFormat(params);
        },
      },
      {
        headerName: "Log Kodu",
        field: "LogCode",
        minWidth: '200'
      },
      {
        headerName: "Mesaj",
        field: "LogMessage",
        minWidth: '500'
      }

    );

    that.columnDefs = responseList;
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.GetUserAllLogList();
  }
  //#endregion agGrid

  public selectFile(event) {
    this.selectedFiles = event.target.files;
  }

  public uploadCancel() {
    this.selectedFiles = undefined;
    this.filesupload.nativeElement.value = '';
  }

  public sessionRenew(model: UserImageRequestModel) {
    const user = JSON.parse(localStorage.getItem('DashboardUser')) as UserResponseModel;
    user.Logo = model.Base64Image.toString();
    localStorage.setItem('DashboardUser', JSON.stringify(user));
  }

  public upload() {
    const reader: FileReader = new FileReader();
    reader.readAsDataURL(this.selectedFiles.item(0));

    reader.onloadend = () => {
      const model = new UserImageRequestModel();
      model.Base64Image = reader.result.toString();
      this.userModel.Logo = reader.result.toString();

      if (model.Base64Image !== null && model.Base64Image !== undefined && model.Base64Image.toString() !== '') {
        this._service.FileUpload(model).then(result => {
          if (!result) {
            this.alertService.showCustomMessage('Hata !', 'Resim yüklemesinde beklenmeyen bir hata oluştu.', 'warning');
            this.uploadCancel();
          } else {
            this.alertService.showCustomMessage('Bilgi !', 'Resim güncellemesi yapıldı.', 'info');
            this.sessionRenew(model);
            AppConfig.setUser();
            this.uploadCancel();
          }
        }).catch((ex: HttpErrorResponse) => {
          this.alertService.showCustomMessage('Hata !', 'Resim yüklemesinde beklenmeyen bir hata oluştu.', 'error');
          this.ThrowException(ex);
          this.uploadCancel();
        });
      }
    };

  }



  public savePassword(userPasswordOld: string, PasswordHashNew: string, PasswordHashNewAgain: string) {

    if (userPasswordOld !== undefined && userPasswordOld !== '') {
      return this._service.ChangePassword(userPasswordOld, PasswordHashNew, PasswordHashNewAgain).then(result => {
        return result;
      }).catch((ex: HttpErrorResponse) => {
        return false;
      });
    }

  }

  public GetUser() {
    this._service.GetUser().then(result => {
      if (result !== undefined) {
        this.userModel = (result || new UserModel()) as UserModel;
        this.userModel.PasswordHash = '';
        this.userModel.PasswordHashNew = '';
        this.userModel.PasswordHashNewAgain = '';
        this.PasswordChange();
      }
    }).catch((ex: HttpErrorResponse) => {
      this.ThrowException(ex);
    });
  }

  public async SaveUser() {

    if (this.userModel.Id !== 0) {
      this.userModel.PhoneNumber = AppHelper.getClearPhoneNumber(this.userModel.PhoneNumber);

      if (this.userModel.UserName === '') {
        this.alertService.showCustomMessage('Uyarı!', 'Lütfen kullanıcı adı alanını boş geçmeyiniz.', 'warning');
      } else if (this.userModel.Email === '') {
        this.alertService.showCustomMessage('Uyarı!', 'Lütfen email alanını boş geçmeyiniz.', 'warning');
      } else if (!AppHelper.ValidateEmail(this.userModel.Email)) {
        this.alertService.showCustomMessage('Uyarı!', 'Lütfen geçerli bir e-mail adresi giriniz.', 'warning');
      } else if (this.userModel.PhoneNumber.length < 10) {
        this.alertService.showCustomMessage('Uyarı!', 'Lütfen geçerli bir telefon numarası yazınız.', 'warning');
      } else {
        this._service.UpdateUser(this.userModel).then(resultuser => {
          this.alertService.showCustomMessage('Bilgi', 'İşleminiz başarıyla tamamlanmıştır.', 'success');
        }).catch((ex: HttpErrorResponse) => {
          this.alertService.showCustomMessage('Bilgi', 'İşleminiz başarısız olmuştur.', 'warning');
          this.ThrowException(ex);
        });
      }
    }

  }

  public SavePaswordChange() {
    if (this.userModel.Id !== 0) {
      if (this.userOldPassword === '') {
        this.alertService.showCustomMessage('Uyarı!', 'Lütfen var olan şifreninizi giriniz.', 'warning');
      } else if (this.userOldPassword === '' || this.userModel.PasswordHashNewAgain === '') {
        this.alertService.showCustomMessage('Uyarı!', 'Lütfen yeni şifrenizi giriniz.', 'warning');
      } else if (this.userModel.PasswordHashNew !== this.userModel.PasswordHashNewAgain) {
        this.alertService.showCustomMessage('Uyarı!', 'Yeni şifre ve yeni şifre tekrar aynı olmalı.', 'warning');
      } else if (this.userModel.PasswordHashNew === this.userOldPassword) {
        this.alertService.showCustomMessage('Uyarı!', 'Yeni girmiş olduğunuz şifre eski şifre ile aynı olamaz.', 'warning');
      } else {
        // tslint:disable-next-line:max-line-length
        this.savePassword(this.userOldPassword,
          this.userModel.PasswordHashNew,
          this.userModel.PasswordHashNewAgain).then(result => {
            if (!result) {
              this.alertService.showCustomMessage('Hata !', 'Şifre değişikliği yapılamadı.', 'error');
            } else {
              this.changePassword = false;
              this.userModel.PasswordHashNew = '';
              this.userModel.PasswordHashNewAgain = '';
              this.userOldPassword = '';
              this._login.logout();
            }

          }).catch((ex: HttpErrorResponse) => {
            this.alertService.showCustomMessage('Bilgi', 'İşleminiz başarısız olmuştur.', 'warning');
            this.changePassword = false;
            this.userModel.PasswordHash = '';
            this.userModel.PasswordHashNew = '';
            this.userModel.PasswordHashNewAgain = '';
            this.userOldPassword = '';

            this.ThrowException(ex);
          });
      }
    }
  }

  public PasswordClear() {
    this.changePassword = false;
    this.userOldPassword = '';
    this.userModel.PasswordHashNew = '';
    this.userModel.PasswordHashNewAgain = '';

  }

  public PasswordChange() {
    if (this.userOldPassword.length > 0) {
      this.passwordChangeStatus = false;
    } else {
      this.passwordChangeStatus = true;
      this.userModel.PasswordHashNew = '';
      this.userModel.PasswordHashNewAgain = '';
    }
  }

  public changesData() {
    this.changePassword = true;
  }


  public getProjectName(codestr: string): string {
    const val = AppConfig.webCode.find(x => x.code === codestr);
    if (val === undefined) {
      return codestr;
    } else {
      return val.name;
    }
  }

  public GetUserAllLogList() {
    let that = this;
    var dataSource = {
      getRows: async function (params) {
        const model = new SearchRequestModel<UserAllLogRequestModel>();
        const user = JSON.parse(localStorage.getItem('DashboardUser')) as UserResponseModel;
        const userSearch = new UserAllLogRequestModel();
        userSearch.UserId = user.Id;
        userSearch.FirmId = user.FirmId;

        model.Query = userSearch;
        model.Take = params.request.endRow - params.request.startRow;
        model.Skip = params.request.startRow;
        let orderByName = 'LogDate';
        let orderByType = 'desc';
        if (params.request.sortModel.length > 0) {
          orderByName = params.request.sortModel[0].colId;
          orderByType = params.request.sortModel[0].sort;
        }
        model.OrderByName = orderByName;
        model.OrderByType = orderByType;
        await that._historyService.GetUserAllLog(model).then((response) => {
          const result = (response || new SearchResponseModel<UserAllLogRequestModel>()) as SearchResponseModel<UserAllLogRequestModel>;
          if (result) {
            setTimeout(function () {
              params.successCallback(result.Results, result.Total);
              that.gridOptions.columnApi.autoSizeColumns(that.gridOptions.columnApi.getAllGridColumns());
            }, 200);
          }
          //that.closeButtonFilter.nativeElement.click();

        })
          .catch((ex: HttpErrorResponse) => {
            AppHelper.ThrowException(ex, that.msgVbt);
          });
      }
    };
    that.gridApi.setServerSideDatasource(dataSource);
  }

  public ThrowException(exception: HttpErrorResponse) {
    const exp = exception.error;
    this.msgVbt.ShowModal('Hata !', exp);
  }

}
